"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var AccountApi = /** @class */ (function () {
    function AccountApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 登录/注册账号
     * @method POST 登录/注册账号
     *
     */
    AccountApi.prototype.login = function () {
        return this.http
            .url("/Account/login")
            .support('POST');
    };
    /**
     * 通过微信登录
     * @method GET 通过微信登录
     *
     */
    AccountApi.prototype.mplogin = function () {
        return this.http
            .url("/Account/mplogin")
            .support('GET');
    };
    /**
     * 添加账号,查询账号列表
     * @method POST 添加账号
     * @method GET 查询账号列表
     *
     */
    AccountApi.prototype.Account = function () {
        return this.http
            .url("/Account")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 获取指定Id账号
     * @method GET 获取指定Id账号
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.AccountByAccountId = function (accountId) {
        return this.http
            .url("/Account/" + accountId)
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取指定用户token
     * @method GET 获取指定用户token
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.token = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/token")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取指定账号钱包
     * @method GET 获取指定账号钱包
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.wallet = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/wallet")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取指定账号收支明细
     * @method GET 获取指定账号收支明细
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.balance = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/wallet/balance")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取指定账号返利明细
     * @method GET 获取指定账号返利明细
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.rebate = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/wallet/rebate")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 向指定账号发送站内消息
     * @method POST 向指定账号发送站内消息
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.send = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/messages/send")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 设置账号角色
     * @method PUT 设置账号角色
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.role = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/role")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 设置账号权限
     * @method PUT 设置账号权限
     *
     * @params accountId 无说明
     */
    AccountApi.prototype.permission = function (accountId) {
        return this.http
            .url("/Account/" + accountId + "/permission")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 邀请码是否来自于会员
     * @method GET 邀请码是否来自于会员
     *
     */
    AccountApi.prototype.referalmember = function () {
        return this.http
            .url("/Account/referalmember")
            .support('GET');
    };
    AccountApi.diOptions = di_1.default.options({
        name: "AccountApi",
        scope: "Singleton"
    });
    return AccountApi;
}());
exports.AccountApi = AccountApi;
exports.default = AccountApi;
